import React from 'react'
import {
  CheckCircleFilled,
  CloseCircleFilled,
  MinusCircleFilled,
} from '@ant-design/icons'

/** The one accent colour on this screen: a completed stage, and the snapshots
 *  that are the thing to act on. */
export const ACCENT = '#0f766e'

const STATUS_ICON: Record<string, React.ReactNode> = {
  OK: <CheckCircleFilled style={{ color: ACCENT }} />,
  WARN: <CheckCircleFilled style={{ color: '#d97706' }} />,
  ERROR: <CloseCircleFilled style={{ color: '#dc2626' }} />,
  SKIPPED: <MinusCircleFilled style={{ color: '#d1d5db' }} />,
}

const PENDING_ICON = (
  <span
    style={{
      display: 'inline-block',
      width: 14,
      height: 14,
      borderRadius: '50%',
      border: '2px solid #d1d5db',
      background: '#fff',
    }}
  />
)

/**
 * The marker and connecting line down the left of a stage list.
 *
 * Shared by both sections so a step reads the same whichever list it is in. The
 * parent row must be a flex container for the line to fill the row's height.
 */
function StageRail({ status, isLast }: { status?: string; isLast: boolean }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 16,
      }}
    >
      <div style={{ height: 4 }} />
      {status ? (STATUS_ICON[status] ?? PENDING_ICON) : PENDING_ICON}
      {!isLast && <div style={{ flex: 1, width: 2, background: '#e5e7eb' }} />}
    </div>
  )
}

export default StageRail
